<template>
  <div>
    <div class="verify">
      <div class="verify_bg"></div>
      <div class="verify_body">
        <div class="verify_title">图形验证码</div>
        <img :src="verifyPic" @click="getPicture" alt>
        <div class="verify_input">
          <input
            type="text"
            autofocus
            v-model="code"
            maxlength="4"
            @keydown="replaceText"
            @keyup="replaceText"
          >
        </div>
      </div>
    </div>
    <loading v-if="needLoading" />
  </div>
</template>

<script>
import { BASE_URL, VERIFYCODE_IMG_URL } from '@/utils/main';
import loading from '../Loading/loading.vue';

export default {
  components: {
    loading,
  },
  name: 'verifyDialog',
  props: {
    pic: {
      url: String,
    },
    callback: Function,
  },
  beforeMount() {
    this.getPicture();
  },
  data() {
    return {
      verifyPic: '',
      code: '',
      needLoading: false,
    };
  },
  methods: {
    getPicture() {
      this.needLoading = true;
      this.$axios({
        method: 'post',
        url: `${BASE_URL}/userinfo/generatePicture`,
        data: {},
      }).then((res) => {
        if (res.data.status === 0) {
          sessionStorage.setItem('captcheId', res.data.content.captcheId);
          this.verifyPic = `${VERIFYCODE_IMG_URL}moon/captcha/v1/get?captchaId=${res.data.content.captcheId}`;
          this.needLoading = false;
        }
      });
    },
    replaceText() {
      this.code = this.code.replace(/\s+/g, '').substr(0, 4);
      if (this.code.length === 4) {
        this.callback(this.code);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
px = (1 / 3.75vw);

.verify {
  z-index: 999;
  .verify_bg {
    background: #000000;
    opacity: 0.7;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index 999;
  }
  .verify_body {
    background: #FFFFFF;
    position: fixed;
    top: px * 90;
    left: px * 38;
    width: px * 300;
    height: px * 230;
    z-index: 1000;
  }
  .verify_title {
    font-size: px * 16;
    font-weight: 700;
    text-align: center;
    color: #1c1c28;
    margin-top: 40px;
    padding: 0 .21rem;
  }
  img {
    width: px * 136
    height: px * 44;
    border: none;
    border-radius: 0 4px 4px 0;
    background: #eef8ff;
    margin: 25px auto auto px * 80;
  }
  .verify_input {
    input {
      border: 1px solid #e4e4e4;
      outline: none;
      width: px * 180;
      height: px * 42;
      box-sizing: border-box;
      font-size: 25 * px;
      text-align: center;
      margin-top: px * 25;
      margin-left: px * 59;
    }
    input:focus {
      border: 1px solid #006737;
    }
  }
}
</style>
